import WarningColored from '@/images/WarningColored.svg';
import {
    Buttons,
    DeleteCloseButton,
    DeleteDialog,
    DeleteText,
    StyledButton,
    Text,
    TitleWithImg,
} from '@/pages/avatar/components/Styled/Modal';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    open: boolean;
    onClose: () => void;
    onCancel: () => void;
}

// TODO: when draft for dvp is implemented this component should be merged with the one from avatar/CreatePage and act the same
// see PR 4095 for more details on how the split occurred
export const LeaveConfirmationModal = ({ open, onClose, onCancel }: Props) => {
    return (
        <DeleteDialog open={open}>
            <div>
                <TitleWithImg>
                    <img src={WarningColored} />
                    <Text>Unsaved changes</Text>
                </TitleWithImg>
                <DeleteCloseButton ariaLabel="close" onClick={onClose}>
                    <CloseIcon />
                </DeleteCloseButton>
            </div>
            <DeleteText>You have unsaved changes, are you sure you want to quit?</DeleteText>
            <Buttons>
                <StyledButton onClick={onClose} variant="outlined" color="secondary">
                    No, stay
                </StyledButton>
                <StyledButton onClick={onCancel} variant="contained" color="secondary">
                    Yes, quit
                </StyledButton>
            </Buttons>
        </DeleteDialog>
    );
};
